import type { WProjectListingCustomizationView } from '@zola/svc-web-api-ts-client';

import { CARD_TYPE_MAP, CardType } from './cardTypes';

// for Customization:
const ORDERED_CUSTOMIZATION_TYPES: CardType[] = [
  'INVITATION',
  CARD_TYPE_MAP.weddingShower,
  'RSVP',
  'SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'DETAILS',
  'ENCLOSURE',
  'MENU',
  'PROGRAM',
  'PLACE',
  CARD_TYPE_MAP.tableNumber,
  'THANK_YOU',
  'ENVELOPE',
  'INVITATION_ENVELOPE',
  'RSVP_ENVELOPE',
  'HOLIDAY',
];
type CustomizationCardType = (typeof ORDERED_CUSTOMIZATION_TYPES)[number];

export const isCustomizationCardType = (type?: string): type is CustomizationCardType => {
  if (!type) return false;
  return ORDERED_CUSTOMIZATION_TYPES.includes(type as CustomizationCardType);
};

export const getCustomizationSort = (type: CardType) => ORDERED_CUSTOMIZATION_TYPES.indexOf(type);

export const sortCustomizationTypes = (
  a: { type: CardType } | WProjectListingCustomizationView,
  b: { type: CardType } | WProjectListingCustomizationView
): number => {
  return getCustomizationSort(a.type as CardType) - getCustomizationSort(b.type as CardType);
};

const PRIMARY_CUSTOMIZATION_TYPES: CardType[] = [
  'INVITATION',
  'SAVE_THE_DATE',
  'DIGITAL_SAVE_THE_DATE',
  'CHANGE_THE_DATE',
  'ENCLOSURE',
  'MENU',
  'PROGRAM',
  'PLACE',
  'THANK_YOU',
  'HOLIDAY',
  CARD_TYPE_MAP.weddingShower,
  CARD_TYPE_MAP.tableNumber,
];

export type PrimaryCustomizationCardType = (typeof PRIMARY_CUSTOMIZATION_TYPES)[number];
export const isPrimaryCustomizationCardType = (
  type?: string
): type is PrimaryCustomizationCardType => {
  if (!type) return false;
  return PRIMARY_CUSTOMIZATION_TYPES.includes(type as PrimaryCustomizationCardType);
};
